export const facetSettings: { loadNotShownValuesAsynchronously: boolean } = $state({
  loadNotShownValuesAsynchronously: false,
});

/**
 *
 *
 */
export function setLoadNotShownValuesAsynchronously(enabled: boolean) {
  facetSettings.loadNotShownValuesAsynchronously = enabled;
}
